

import { useState } from "react";

export default function BackgroundVideo() {
  const [showImage, setShowImage] = useState(false);

  const handleMouseEnter = () => setShowImage(true);
  const handleMouseLeave = () => setShowImage(false);

  return (
    <div>
      {/* Wrapper for background video and hover image */}
      <div
        className="background-wrapper"
        onMouseMove={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Background Video */}
        <video autoPlay muted loop id="backgroundVideo">
          <source src="/leeroy-background.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Conditional Hover Image */}
        {showImage && (
          <img
            src="/bg-hove-image.webp"
            alt="HoverImage"
            className="hoverImage"
          />
        )}
      </div>

    

      {/* Styles */}
      <style jsx>{`
        html,
        body {
          margin: 0;
          padding: 0;
          height: 100%;
         
        }

        .background-wrapper {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: -1; /* Places behind content */
        }

        #backgroundVideo {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .hoverImage {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 1;
          pointer-events: none; /* Prevent interference with mouse events */
        }

        .content {
          position: relative;
          color: white;
          text-align: center;
        
          font-family: Arial, sans-serif;
        }
      `}</style>
    </div>
  );
}
